import { render, staticRenderFns } from "./Footer2.vue?vue&type=template&id=5d9dfdce&scoped=true"
import script from "./Footer2.vue?vue&type=script&lang=js"
export * from "./Footer2.vue?vue&type=script&lang=js"
import style0 from "./Footer2.vue?vue&type=style&index=0&id=5d9dfdce&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9dfdce",
  null
  
)

export default component.exports